// src/api/account.js
import { apiCall, API_BASE_URL } from "@/api/client";
import { getOrCreateInstallationId } from "@/lib/installationId";
import { getNativeAuthReturnScheme } from "@/lib/nativeAppLinks";

// ====== Profil / konto ======
export const getAccount = () => apiCall("/api/account/me");

export const updateProfile = (payload) =>
    apiCall("/api/account/profile", {
        method: "PUT",
        body: JSON.stringify({
            ...payload,
            native_return_scheme: getNativeAuthReturnScheme(),
        }),
    });

export const updateFavoriteTeam = (favoriteTeamId) =>
    apiCall("/api/account/favorite-team", {
        method: "PUT",
        body: JSON.stringify({ favorite_team_id: favoriteTeamId || null }),
    });

export const changePassword = ({ current_password, new_password }) =>
    apiCall("/api/account/password", {
        method: "PUT",
        body: JSON.stringify({ current_password, new_password }),
    });

// ====== Notiser ======
export const getNotifications = () => apiCall("/api/account/notifications");

export const updateNotifications = (payload) =>
    apiCall("/api/account/notifications", {
        method: "PUT",
        body: JSON.stringify(payload), // t.ex. { email: {...}, push: {...}, quietHours: {...} }
    });

export const getPrivacyPreferences = () => apiCall("/api/account/privacy-preferences");

export const updatePrivacyPreferences = (payload) =>
    apiCall("/api/account/privacy-preferences", {
        method: "PUT",
        body: JSON.stringify(payload),
    });

export const getComplianceStatus = () => apiCall("/api/account/compliance-status");

export const updateComplianceStatus = (payload) =>
    apiCall("/api/account/compliance-status", {
        method: "PUT",
        body: JSON.stringify(payload),
    });

export const getPreferences = () => apiCall("/api/account/preferences");

export const updatePreferences = (payload) =>
    apiCall("/api/account/preferences", {
        method: "PUT",
        body: JSON.stringify(payload),
    });


// ====== Web Push ======
export const getPushPublicKey = () => apiCall("/api/account/push/public-key");

export const subscribePush = (sub) =>
    apiCall("/api/account/push/subscribe", {
        method: "POST",
        body: JSON.stringify(sub), // { endpoint, keys:{p256dh,auth} }
    });

export const unsubscribePush = ({ endpoint, installation_id }) =>
    apiCall("/api/account/push/subscribe", {
        method: "DELETE",
        body: JSON.stringify({ endpoint, installation_id }),
    });

export const subscribeNativePush = (subscription) =>
    apiCall("/api/account/push/native/subscribe", {
        method: "POST",
        body: JSON.stringify(subscription),
    });

export const unsubscribeNativePush = ({ installation_id, platform }) =>
    apiCall("/api/account/push/native/subscribe", {
        method: "DELETE",
        body: JSON.stringify({ installation_id, platform }),
    });

export const testPush = () =>
    apiCall("/api/account/push/test", { method: "POST" });

export const diagnosePush = () =>
    apiCall("/api/account/push/diagnose");



// ====== Sessioner / enheter ======
export const getSessions = () => apiCall("/api/account/sessions");

export const revokeSession = (sessionId) =>
    apiCall(`/api/account/sessions/${sessionId}`, { method: "DELETE" });

export const revokeAllOtherSessions = () =>
    apiCall(`/api/account/sessions`, {
        method: "DELETE",
        body: JSON.stringify({ scope: "others" }),
    });

// ====== 2FA ======
export const startEnable2FA = () =>
    apiCall("/api/account/2fa/enable", { method: "POST" }); // -> { otpauth_url, secret, qrcodeDataUrl? }

export const verify2FA = (code) =>
    apiCall("/api/account/2fa/verify", {
        method: "POST",
        body: JSON.stringify({ code }),
    });

export const disable2FA = () =>
    apiCall("/api/account/2fa/disable", { method: "POST" });

// ====== Export / Delete ======
export const exportMyData = async () => {
    const token = localStorage.getItem("speedway_token");
    const installationId = getOrCreateInstallationId();
    const res = await fetch(`${API_BASE_URL}/api/account/export`, {
        headers: {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...(installationId ? { "X-Lapstr-Installation-Id": installationId } : {}),
        },
    });
    if (!res.ok) throw new Error("Kunde inte exportera data");
    const blob = await res.blob();
    return blob; // låt komponenten ladda ned
};

export const deleteAccount = ({ password }) =>
    apiCall("/api/account/", {
        method: "DELETE",
        body: JSON.stringify({ password }),
    });
